import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  POST_SALES_CORPORATE,
  POST_SALES_APARTMENT,
  CAT_BY_PRODUCT,
  CAT_BY_BRAND,
  TAG,
} from "./type";

export const postCorporate = (leadId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.corporate}${leadId}`
  );
  if (res?.data?.status === true || res?.data?.status === 0) {
    const { data } = res;
    dispatch({ type: POST_SALES_CORPORATE, payload: data.response.data });
    return true;
  }
};

export const postApartment = (leadId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.appartment}${leadId}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    const data = payload?.data ?? outer?.data;
    dispatch({ type: POST_SALES_APARTMENT, payload: data });
    return data;
  }
};

export const getMateriaById = (id,brand_id=null) => async (dispatch) => {
  const req = {"cat_id":id,"brand_id":brand_id};
  const res = await callWebService(
    callTypes.post,
    req,
    `${Config.postSales.getMaterial}${id}`
  );
  if (res?.data?.status === true) {
    const { data } = res;
    dispatch({ type: CAT_BY_PRODUCT, payload: data.response.data });
    return data.response.data;
  }
};
export const getBrandById = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    "",
    `${Config.postSales.getBrand}${id}`
  );
  if (res?.data?.status === true) {
    const { data } = res;
    dispatch({ type: CAT_BY_BRAND, payload: data.response.data });
    return data.response.data;
  }
};

export const getTagById = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    "",
    `${Config.postSales.getTag}`
  );
  if (res?.data?.status === true) {
    const { data } = res;
    dispatch({ type: TAG, payload: data.response.data });
    return true;
  }
};
